import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Base = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.baseList);

	const baseResponse = data.map((item) => ({
		...item,
		id: item?.constant
	}));

	return (
		<>
			<FilterName type="BASE" />
			<Checkbox data={baseResponse} type="BASE" handleSearch={handleSearch} />
		</>
	);
};

export default Base;
